import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@mui/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Tooltip from "@mui/material/Tooltip";
import download from '../images/download-doc.svg';
import "react-daterange-picker/dist/css/react-calendar.css";
import "date-fns";
import spinner from '../../assign-prescriptions/images/spinner.gif';
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import SwipeableViews from 'react-swipeable-views';
import { AppBar, Tabs, Tab, Grid, Avatar } from '@mui/material';
import Typography from '@mui/material/Typography';
import Dashboard from '../temparature_monitoring/Dashboard';
import { IconButton } from "@mui/material";
import Box from '@mui/material/Box';
import moment from 'moment-timezone';
import { withTranslation } from "react-i18next";
import getTypeByLang from '../../common/typeByLang';
import ReportsAGGrid from "../reportsGrid/reportsAGGrid";
import CloseIcon from '@mui/icons-material/Close';

function TabContainer({ children, dir }) {
  return (
    <Typography component="div" dir={dir} style={{ padding: 8 * 3 }}>
      {children}
    </Typography>
  );
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
  dir: PropTypes.string.isRequired,
};

const styles = theme => ({
  root: {
    width: "100%",
  },
  padding10px: {
    padding: '10px'
  },
  spinner: {
    position: 'absolute',
    background: 'rgba(255,255,255,.4)',
    width: '100%',
    height: '100%',
    zIndex: '9999',
    top: 0,
    left: 0,
  },
  spinnerImage: {
    top: 'calc(50% - 32.5px)',
    left: 'calc(50% - 65px)',
    position: 'absolute',
    width: '130px',
    userSelect: 'none'
  },
  rowheight: {
    height: '35px'
  },
  primaryButton: {
    background: '#6cca98',
    color: '#fff',
    '&:hover': {
      background: '#6cca98',
      color: '#fff',
    },
    '&:disabled': {
      color: 'rgba(0, 0, 0, 0.38)',
      cursor: 'not-allowed',
      background: '#E4E5E8'
    },
  }
});

const TransactionSortObj = {
  firstname: { tableName: 'customers', sortColumn: 'first_name' },
  lastname: { tableName: 'customers', sortColumn: 'last_name' },
  member_id: { tableName: '', sortColumn: 'member_id' },
  store: { tableName: 'accounts', sortColumn: 'name' },
  box: { tableName: 'boxes', sortColumn: 'name' },
  binid: { tableName: '', sortColumn: 'bin_id' },
  rxno: { tableName: 'prescription_detail', sortColumn: 'rx_no' },
  fillid: { tableName: 'prescription_detail', sortColumn: 'fillnumber' },
  prescriptionnumber: { tableName: 'prescription_detail', sortColumn: 'prescriptionnumber' },
  ndccode: { tableName: 'prescription_detail', sortColumn: 'ndc_code' },
  drugname: { tableName: 'prescription_detail', sortColumn: 'drug_name' },
  qty: { tableName: 'prescription_detail', sortColumn: 'qty' },
  price: { tableName: 'prescription_detail', sortColumn: 'price' },
  stockeddate: { tableName: '', sortColumn: 'stocked_date' },
  pickupdate: { tableName: '', sortColumn: 'pickup_date' },
  stock_code: { tableName: '', sortColumn: 'stock_code' },
  pucode: { tableName: '', sortColumn: 'pucode' },
  deliverytype: { tableName: 'locationtype_master', sortColumn: 'name' },
  order_id: { tableName: 'prescription_detail', sortColumn: 'order_id' },
  prescription_txn_id: { tableName: 'prescription_detail', sortColumn: 'prescription_txn_id' },
}

let TransactionFilterObj = {
  store_ids: [],
  box_ids: [],
  searchObject: null,
  stockeddate: {
    fromdate: '',
    todate: '',
  },
  pickupdate: {
    fromdate: '',
    todate: '',
  },
  pageNo: 0,
  pageSize: 25,
  sortOrder: 'desc',
  sortColumn: 'pickup_date',
  tableName: ''
}

const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
const findOffset = moment().tz(timeZone).utcOffset();
const defaultZone = `(UTC ${findOffset}) ${timeZone}`;

class EnhancedTable extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      rowsPerPage: 25,
      boxvalues: [],
      accountValues: [],
      loader: false,
      selectedObject: null,
      selectedTab: 0,
      tempThresholds: [],
      isButtonDisabled: false,
      data: []
    };
  }

  componentDidMount() {
    this.setState({ loader: true });
    fetch(process.env.REACT_APP_BASEURL + "accounts", {
      method: 'GET',
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
        'Content-Type': 'application/json'
      }
    })
      .then(response => response.json())
      .then(accounts => {
        const storelist = accounts.map(account => {
          return { id: account.id, name: account.name };
        });

        this.setState({ accountValues: storelist, parent_account_id: storelist[0].id });
        this.BindBoxesbyStoreId(storelist.map(x => x.id));
        this.setState({ loader: false });
      });
  }

  convertToTimeZone = (requestDate) => {
    const currentUserLang = localStorage.getItem('i18nextLng');
    let zone;
    zone = sessionStorage.getItem('timeZone');
    const date = moment(new Date(requestDate));
    if (['null', null, 'undefined', undefined].includes(zone)) {
      zone = defaultZone;
    }
    return currentUserLang === 'en' ? date.tz(zone.substring(zone.lastIndexOf(' ') + 1)).format('MM/DD/YYYY hh:mm:ss A') : date.tz(zone.substring(zone.lastIndexOf(' ') + 1)).format('DD/MM/YYYY hh:mm:ss A');
  }

  exportCSV() {
    this.setState({ loader: true });
    fetch(process.env.REACT_APP_BASEURL + 'CSV/PayrollDeductReport', {
      method: 'POST',
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(TransactionFilterObj)
    })
      .then(response => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then((csvData) => {
        this.setState({ loader: false });
        let csvRow = [];
        let Array = [['ID', 'Badge Number', 'Date', 'Timestamp', 'Amount']];
        let result = csvData && csvData.Results && csvData.Results.length > 0 ? csvData.Results : [];
        if (result !== undefined && result !== 'undefined') {
          if (result && result.length > 0) {
            for (let i of result) {
              Array.push(
                [
                  i.member_id ? i.member_id : '[NULL]',
                  i.pickupdate ? this.convertToTimeZone(i && i.pickupdate) : '[NULL]',
                  i.time_stamp ? i.time_stamp : '[NULL]',
                  i.amount ? '$' + parseFloat(i.amount).toFixed(2) : '$0.00',
                ]

              );
            }

            for (let i of Array) {
              csvRow.push(i.join(","));
            }
            let csvString = csvRow.join("%0A");
            let element = document.createElement("a");
            element.href = 'data:attachment/csv.' + csvString;
            element.target = "_Blank";
            element.download = "PickedUpItemsReport.csv";
            document.body.appendChild(element);
            element.click();
          }
        }
      });
  };

  //Bind Boxes by store id
  BindBoxesbyStoreId(store_ids) {
    if (store_ids.length > 0) {
      this.setState({ loader: true });
      let BoxesObj = {
        store_ids: store_ids
      }
      fetch(process.env.REACT_APP_BASEURL + 'getBoxesByStoreIds', {
        method: 'post',
        withCredentials: true,
        headers: {
          'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(BoxesObj)
      })
        .then(response => {
          try {
            return response.json();
          } catch (error) {
            return null;
          }
        })
        .then(data => {
          const boxlist = data.map(account => {
            return { id: account.id, name: account.name };
          });
          this.setState({ boxvalues: boxlist });
          this.setState({ loader: false });
        });
    }
  }

  onGridReady = (params) => {
    this.gridApi = params.api
    const datasource = this.getServerSideDatasource(this.state.boxvalues, this.state.accountValues)
    // register datasource with the grid
    this.gridApi.setServerSideDatasource(datasource);
  }

  clearFilters = () => {
    const filterModel = this.gridApi.getFilterModel();
    if (Object.keys(filterModel).length > 0) {
      this.gridApi.setFilterModel(null);
      TransactionFilterObj.searchObject = null;
      TransactionFilterObj.box_ids = [];
      TransactionFilterObj.store_ids = [];
      TransactionFilterObj.stockeddate.fromdate = '';
      TransactionFilterObj.stockeddate.todate = '';
      TransactionFilterObj.pickupdate.fromdate = '';
      TransactionFilterObj.pickupdate.todate = '';
      this.gridApi.refreshServerSide();
    }
  };

  getServerSideDatasource = (boxvalues, accountValues) => {
    const self = this;
    return {
      getRows(params) {
        TransactionFilterObj.pageNo = Math.floor(params.request.startRow / self.state.rowsPerPage)

        const filterObject = params.request && params.request.filterModel
        const filterColumns = Object.keys(filterObject)

        // to set box_ids
        if (filterObject.box) {
          const filterValues = filterObject.box.values;
          if (filterValues.length > 0) {
            TransactionFilterObj.box_ids = boxvalues.filter(boxes => {
              return filterValues.includes(boxes.name)
            }).map(box => box.id)
          }
        } else {
          TransactionFilterObj.box_ids = []
        }

        // to set store_ids
        if (filterObject.store) {
          const filterValues = filterObject.store.values;
          TransactionFilterObj.store_ids = accountValues.filter(accounts => {
            return filterValues.includes(accounts.name)
          }).map(store => store.id)
        } else {
          TransactionFilterObj.store_ids = []
        }

        // to set fromdate and todate for stocked date
        if (filterObject.stockeddate) {
          const dateValue = filterObject.stockeddate;
          if (dateValue.operator) {
            // for date range
            if (dateValue.condition1.type === 'fromdate' && dateValue.condition2.type === 'todate') {
              const date1 = moment(dateValue.condition1.dateFrom).format('YYYY-MM-DD')
              const date2 = moment(dateValue.condition2.dateFrom).format('YYYY-MM-DD')
              TransactionFilterObj.stockeddate.fromdate = date1
              TransactionFilterObj.stockeddate.todate = date2
            }
            if (dateValue.condition2.type === 'fromdate' && dateValue.condition1.type === 'todate') {
              const date2 = moment(dateValue.condition1.dateFrom).format('YYYY-MM-DD')
              const date1 = moment(dateValue.condition2.dateFrom).format('YYYY-MM-DD')
              TransactionFilterObj.stockeddate.fromdate = date1
              TransactionFilterObj.stockeddate.todate = date2
            }
          } else {
            // for from/to date
            const date = moment(dateValue.dateFrom).format('YYYY-MM-DD')
            if (dateValue.type === 'fromdate') {
              TransactionFilterObj.stockeddate.fromdate = date
              TransactionFilterObj.stockeddate.todate = ''
            } else {
              TransactionFilterObj.stockeddate.todate = date
              TransactionFilterObj.stockeddate.fromdate = ''
            }
          }
        } else {
          TransactionFilterObj.stockeddate.todate = '';
          TransactionFilterObj.stockeddate.fromdate = ''
        }

        // to set fromdate and todate for picked up date
        if (filterObject.pickupdate) {
          const dateValue = filterObject.pickupdate;
          if (dateValue.operator) {
            // for date range
            if (dateValue.condition1.type === 'fromdate' && dateValue.condition2.type === 'todate') {
              const date1 = moment(dateValue.condition1.dateFrom).format('YYYY-MM-DD')
              const date2 = moment(dateValue.condition2.dateFrom).format('YYYY-MM-DD')
              TransactionFilterObj.pickupdate.fromdate = date1
              TransactionFilterObj.pickupdate.todate = date2
            }
            if (dateValue.condition2.type === 'fromdate' && dateValue.condition1.type === 'todate') {
              const date2 = moment(dateValue.condition1.dateFrom).format('YYYY-MM-DD')
              const date1 = moment(dateValue.condition2.dateFrom).format('YYYY-MM-DD')
              TransactionFilterObj.pickupdate.fromdate = date1
              TransactionFilterObj.pickupdate.todate = date2
            }
          } else {
            // for from/to date
            const date = moment(dateValue.dateFrom).format('YYYY-MM-DD')
            if (dateValue.type === 'fromdate') {
              TransactionFilterObj.pickupdate.fromdate = date
              TransactionFilterObj.pickupdate.todate = ''
            } else {
              TransactionFilterObj.pickupdate.todate = date
              TransactionFilterObj.pickupdate.fromdate = ''
            }
          }
        } else {
          TransactionFilterObj.pickupdate.todate = '';
          TransactionFilterObj.pickupdate.fromdate = ''
        }

        if (filterObject) {
          if (filterColumns.length === 0) {
            TransactionFilterObj.searchObject = null
          } else {
            TransactionFilterObj.searchObject = filterObject
          }
        }

        if (params.request.sortModel.length > 0) {
          TransactionFilterObj.tableName = TransactionSortObj[params.request.sortModel[0].colId].tableName
          TransactionFilterObj.sortColumn = TransactionSortObj[params.request.sortModel[0].colId].sortColumn
          TransactionFilterObj.sortOrder = params.request.sortModel[0].sort
        }

        // const element = document.activeElement

        const isStoreNotSelected = Boolean(filterObject.store && filterObject.store.values.length === 0)
        const isBoxNotSelected = Boolean(filterObject.box && filterObject.box.values.length === 0)

        // if (filterColumns.length > 0) { // if true means filter or cleared filters means api call
        if (isStoreNotSelected === true || isBoxNotSelected === true) {
          // store or box is not selected, so empty data
          params.successCallback([], 0)
          self.setState({ data: [], isButtonDisabled: true })
        } else { // store or box is selected
          //     if (element && element.getAttribute("aria-label") === "BIN Filter Input") { // bypass validation for binid
          apiCall()
          //     } else {
          //       if (element && element.value && (element.value.length >= 3 || element.value === "on")) {
          //         // validation or selection of store & box or page change
          //         apiCall()
          //       } else {
          //         params.successCallback(self.state.data, self.state.data.length)
          //       }
          //     }
        }
        // } else { // for clear filter
        // apiCall()
        // }

        function apiCall() {
          self.setState({ loader: true });
          fetch(process.env.REACT_APP_BASEURL + 'getPayrollDeductReport', {
            method: 'post',
            withCredentials: true,
            headers: {
              Authorization:
                'Bearer ' +
                JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
                  .jwtToken,
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(TransactionFilterObj),
          })
            .then((httpResponse) => {
              try {
                return httpResponse.json();
              } catch (error) {
                return null;
              }
            })
            .then((response) => {
              if (response && response.results) {
                if (response.results.length > 0) {
                  params.successCallback(response.results, response.total);
                  self.setState({ data: response.results, isButtonDisabled: false })
                } else {
                  params.successCallback([], 0);
                  self.setState({ data: [], isButtonDisabled: true })
                }
                self.setState({ loader: false })
              }
            })
            .catch(error => {
              self.setState({ loader: false })
              console.error(error);
              params.failCallback();
            });
        }
      }
    };
  }

  LinkValueRenderer = (params) => {
    return (
      <a
        href=''
        title='View Pick up by'
        style={{
          color: '#385cad',
          fontWeight: 500,
          textDecoration: 'none ',
          fontSize: '1rem',
        }}
        onClick={(event) =>
          this.handlePUcodeClick(event, params.data.pmid)
        }
      >
        {' '}
        {params.value}
      </a>
    )
  }

  handlePUcodeClick = (event, pmid) => {
    event.preventDefault();
    this.setState({ tempThresholds: [] });
    const selectedObject = this.state.data.find(x => x.pmid === pmid);
    this.setState({ detailDialogOpen: true, selectedObject: selectedObject })
    this.setState({
      boxAddress: (selectedObject.address_line_1 + ' '
        + selectedObject.address_line_2 + ','
        + selectedObject.city + ', '
        + selectedObject.state + ' '
        + selectedObject.zip + '')
    })
  }

  handlePUcodeClose = (event) => {
    event.preventDefault();
    this.setState({ detailDialogOpen: false, selectedObject: null, selectedTab: 0 })
  }

  handlePrintReceipt = () => {
    this.setState({ detailDialogOpen: false, printDialogOpen: true })
    setTimeout(() => {
      window.print();
      this.setState({ printDialogOpen: false, detailDialogOpen: false, selectedObject: null })
    }, 100);
  }

  handleTabChange = (event, index) => {
    this.setState({ selectedTab: index });
  };

  handleChangeIndex(index) {
    this.setState({ selectedTab: index });
  };

  handleTemperatureHistory = () => {
    this.getTemperatureHistoryByOrderId();
  }

  getTemperatureHistoryByOrderId = () => {
    let temperatureHistory = {
      startdate: this.state.selectedObject.stockeddate,
      enddate: this.state.selectedObject.pickupdate,
      orderId: this.state.selectedObject.pmid
    }
    fetch(process.env.REACT_APP_BASEURL + 'temperature/history/by/expansion', {
      method: 'post',
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(temperatureHistory)
    }).then(response => {
      try {
        return response.json();
      } catch (error) {
        return null;
      }
    }).then(tempData => {
      if (tempData && tempData.length > 0) {
        this.setState({ tempThresholds: tempData });
      }
    });
  }

  exportTemperatureHistory = () => {
    let csvRow = [];
    let A = [['', 'Temperature', 'Date']];
    let re = this.state !== null ? this.state.tempThresholds : [];
    if (re !== undefined) {
      if (re.length > 0) {
        for (let item = 0; item < re.length; item++) {
          A.push([re[item].temperature,
          re[item].date ? this.convertToTimeZone(re[item].date) : '',
          ]);
        }
        for (let i = 0; i < A.length; ++i) {
          csvRow.push(A[i].join(","));
        }
        let csvString = csvRow.join("%0A");
        let a = document.createElement("a");
        a.href = 'data:attachment/csv.' + csvString;
        a.target = "_Blank";
        a.download = `TemperatureHistory_${new Date()}.csv`;
        document.body.appendChild(a);
        a.click();
      }
    }
  }

  DateCellFormatter = (params) => {
    return this.convertToTimeZone(params.value)
  }

  DeliveryTypeFormatter = (t) => {
    return (params) => {
      const deliverType = getTypeByLang(params.value, t)
      return deliverType ? deliverType : ''
    }
  }

  AmountValueRenderer = (params) => {
    return params.value ? '$' + parseFloat(params.value).toFixed(2) : '$0.00'
  }

  render() {
    const { classes, theme, t } = this.props;
    const { data, accountValues, boxvalues } = this.state;

    const columnDefs = [
      { field: "firstname", headerName: t("Report.Payroll.FirstName"), },
      { field: "lastname", headerName: t("Report.Payroll.LastName") },
      { field: "rxno", headerName: t("Report.Payroll.RxHash") },
      { field: "prescriptionnumber", headerName: t("Report.Payroll.PrescriptionNumber") },
      { field: "drugname", headerName: t("Report.Payroll.DrugName") },
      { field: "stock_code", headerName: t("Report.Payroll.StockCode") },
      { field: "pucode", headerName: t("Report.Payroll.PUCode"), cellRenderer: this.LinkValueRenderer },
      {
        field: "store", headerName: t("Report.Payroll.Store"), filter: true,
        filterParams: {
          values: accountValues.map(account => {
            return account.name
          })
        },
        menuTabs: ['generalMenuTab', 'columnsMenuTab'],
      },
      {
        field: "box", headerName: t("Report.Payroll.Location"), filter: true,
        filterParams: {
          values: boxvalues.map(box => {
            return box.name
          })
        },
        menuTabs: ['generalMenuTab', 'columnsMenuTab'],
      },
      { field: "deliverytype", headerName: t("Report.Payroll.DeliverType"), cellRenderer: this.DeliveryTypeFormatter(t) },
      { field: "binid", headerName: t("Report.Payroll.BIN") },
      { field: "fillid", headerName: t("Report.Payroll.FillID") },
      { field: "order_id", headerName: t("Report.Payroll.OrderID") },
      { field: "prescription_txn_id", headerName: t("Report.Payroll.TransactionID") },
      { field: "ndccode", headerName: t("Report.Payroll.NDCCode") },
      { field: "qty", headerName: t("Report.Payroll.Qty"), filter: false },
      { field: "price", headerName: t("Report.Payroll.AmountDue"), filter: false, cellRenderer: this.AmountValueRenderer },
      { field: "member_id", headerName: t("Report.Payroll.BadgeNumber") },
      {
        field: "stockeddate", headerName: t("Report.Payroll.StockDate"),
        cellRenderer: this.DateCellFormatter,
        filter: 'agDateColumnFilter',
        filterParams: {
          filterOptions: [
            {
              displayKey: 'fromdate',
              displayName: t('Report.Payroll.FromDate'),
              predicate: (_, cellValue) => cellValue
            },
            {
              displayKey: 'todate',
              displayName: t('Report.Payroll.ToDate'),
              predicate: (_, cellValue) => cellValue
            },
          ],
          maxNumConditions: 2,
        },
      },
      {
        field: "pickupdate", headerName: t("Report.Payroll.PickUpDate"),
        cellRenderer: this.DateCellFormatter,
        filter: 'agDateColumnFilter',
        filterParams: {
          filterOptions: [
            {
              displayKey: 'fromdate',
              displayName: t('Report.Payroll.FromDate'),
              predicate: (_, cellValue) => cellValue
            },
            {
              displayKey: 'todate',
              displayName: t('Report.Payroll.ToDate'),
              predicate: (_, cellValue) => cellValue
            },
          ],
          maxNumConditions: 2,
        },
      },
    ];

    return (
      <div id="react-no-print" className={classes.root}>
        {
          this.state.loader ?
            <div className={classes.spinner}>
              <img className={classes.spinnerImage} src={spinner} alt="loading" />
            </div> :
            null
        }
        <div id="react-no-print">
          <Dialog
            open={this.state.detailDialogOpen || false}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            PaperProps={{
              style: { borderRadius: '5px', maxWidth: '100%', width: '60%' }
            }}
          >
            <AppBar position="static" color="default">
              <Tabs
                value={this.state.selectedTab}
                onChange={this.handleTabChange}
                indicatorColor="primary"
                textColor="primary"
                variant={null}
              >
                <Tab label={t("Report.Payroll.PatientDetail.PatientDetailsTitle")} />
                <Tab label={t("Report.Payroll.Temperature.TemperatureHistoryTitle")} onClick={this.handleTemperatureHistory} />
              </Tabs>
            </AppBar>
            <SwipeableViews
              axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
              index={this.state.selectedTab}
              onChangeIndex={() => this.handleChangeIndex}
            >
              <TabContainer dir={theme.direction}>
                <DialogTitle id="alert-dialog-title">{t("Report.Payroll.PatientDetail.PickupByText")}</DialogTitle>
                <DialogContent>
                  <Table aria-labelledby="tableTitle">
                    <TableHead>
                      <TableRow>
                        <TableCell className={classes.padding10px} style={{ color: 'grey' }}>{t("Report.Payroll.PatientDetail.FirstName")}</TableCell>
                        <TableCell className={classes.padding10px} style={{ color: 'grey' }}>{t("Report.Payroll.PatientDetail.LastName")}</TableCell>
                        <TableCell className={classes.padding10px} style={{ color: 'grey' }}>{t("Report.Payroll.PatientDetail.BadgeNumber")}</TableCell>
                        <TableCell className={classes.padding10px} style={{ color: 'grey' }}>{t("Report.Payroll.PatientDetail.ContactlessPickup")}</TableCell>
                        <TableCell className={classes.padding10px} style={{ color: 'grey' }}>{t("Report.Payroll.PatientDetail.DLNo")}</TableCell>
                        <TableCell className={classes.padding10px} style={{ color: 'grey' }}>{t("Report.Payroll.PatientDetail.Signature")}</TableCell>
                        <TableCell className={classes.padding10px} style={{ color: 'grey' }}>{t("Report.Payroll.PatientDetail.Picture")}</TableCell>
                        <TableCell className={classes.padding10px} style={{ color: 'grey' }}>{t("Report.Payroll.PatientDetail.Relationship")}</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {
                        this.state.selectedObject !== null ?
                          <TableRow>
                            <TableCell className={classes.padding10px} >{this.state.selectedObject.pfirst_name ? this.state.selectedObject.pfirst_name : ''}</TableCell>
                            <TableCell className={classes.padding10px}>{this.state.selectedObject.plast_name ? this.state.selectedObject.plast_name : ''}</TableCell>
                            <TableCell className={classes.padding10px}>{this.state.selectedObject.iscontactlessactivated === true ? 'Yes' : 'No'}</TableCell>
                            <TableCell className={classes.padding10px}>{this.state.selectedObject.pdrivers_license_no ? this.state.selectedObject.pdrivers_license_no : ''}</TableCell>
                            <TableCell className={classes.padding10px}><img style={{ borderRadius: '0%', width: '230px', height: '150px' }} alt="" src={(this.state.selectedObject.psignature_url !== null && this.state.selectedObject.psignature_url !== '') ? this.state.selectedObject.psignature_url : 'https://upload.wikimedia.org/wikipedia/commons/a/ac/No_image_available.svg'} /></TableCell>
                            <TableCell className={classes.padding10px}><Avatar style={{ borderRadius: '0%', width: '150px', height: '150px' }} alt="" src={(this.state.selectedObject.ppicture_url !== null && this.state.selectedObject.ppicture_url !== '') ? this.state.selectedObject.ppicture_url : 'https://upload.wikimedia.org/wikipedia/commons/a/ac/No_image_available.svg'} /></TableCell>
                            <TableCell className={classes.padding10px}>{this.state.selectedObject.relationship ? this.state.selectedObject.relationship.replace('_', ' ').replace('_', ' ') : ''}</TableCell>
                          </TableRow>
                          :
                          <TableRow>
                            <TableCell colSpan={5}>{t("Report.Payroll.NoDataFound")}</TableCell>
                          </TableRow>
                      }
                    </TableBody>
                  </Table>
                </DialogContent>
              </TabContainer>
              <TabContainer dir={theme.direction}>
                <DialogTitle id="form-dialog-title">{t("Report.Payroll.Temperature.TemperatureHistoryText")}</DialogTitle>
                <DialogContent>
                  <Grid container>
                    <Grid item xs={11} className="font-style">
                      &nbsp;
                    </Grid>
                    <Grid item xs={1} className="font-style">
                      <img alt="download" onClick={() => { this.exportTemperatureHistory() }} src={download} style={{ height: '32px', width: '32px', cursor: 'pointer' }} />
                    </Grid>
                  </Grid>
                  <Dashboard data={this.state && this.state.tempThresholds} startDate={this.state && this.state.selectedObject && this.state.selectedObject.stockeddate} endDate={this.state && this.state.selectedObject && this.state.selectedObject.pickupdate} margin="0%" convertTimeZone={this.convertToTimeZone} />
                </DialogContent>
              </TabContainer>
            </SwipeableViews>
            <DialogActions>
              <Button onClick={(e) => { this.handlePrintReceipt(e) }} color="primary" className={classes.primaryButton}>
                {t("Report.Payroll.Temperature.PrintReceiptButton")}
              </Button>
              <Button onClick={(e) => { this.handlePUcodeClose(e) }} color="primary" className={classes.primaryButton}>
                {t("Report.Payroll.Temperature.CloseButton")}
              </Button>
            </DialogActions>
          </Dialog>
        </div>
        <div>
          <Dialog
            open={this.state.printDialogOpen || false}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            fullWidth={true}
            PaperProps={{
              style: { maxWidth: '700px', maxHeight: '100%' }
            }}
          >
            <DialogTitle id="alert-dialog-title">{t("Report.Payroll.Receipt.PickedUpReceipt")}</DialogTitle>
            <DialogContent>
              <Table aria-labelledby="tableTitle">
                {
                  this.state.selectedObject !== null ?
                    (<TableBody>
                      <TableRow className={classes.rowheight}>
                        <TableCell>{t("Report.Payroll.Receipt.PharmacyName")}:</TableCell>
                        <TableCell>{this.state.selectedObject.store}</TableCell>
                      </TableRow>
                      <TableRow className={classes.rowheight}>
                        <TableCell>{t("Report.Payroll.Receipt.KioskName")}:</TableCell>
                        <TableCell>{this.state.selectedObject.box}</TableCell>
                      </TableRow>
                      <TableRow className={classes.rowheight}>
                        <TableCell>{t("Report.Payroll.Receipt.Address")}:</TableCell>
                        <TableCell>{this.state && this.state.boxAddress}</TableCell>
                      </TableRow>
                      <TableRow className={classes.rowheight}>
                        <TableCell>{t("Report.Payroll.Receipt.PickupOrder")}:</TableCell>
                        <TableCell>{this.state.selectedObject.pucode}</TableCell>
                      </TableRow>
                      <TableRow className={classes.rowheight}>
                        <TableCell>{t("Report.Payroll.Receipt.PickupDate")}:</TableCell>
                        <TableCell>{this.state.selectedObject.pickupdate ? this.convertToTimeZone(this.state.selectedObject.pickupdate) : ''}</TableCell>
                      </TableRow>
                      <TableRow className={classes.rowheight}>
                        <TableCell>{t("Report.Payroll.Receipt.StockDate")}:</TableCell>
                        <TableCell>{this.state.selectedObject.stockeddate ? this.convertToTimeZone(this.state.selectedObject.stockeddate) : ''}</TableCell>
                      </TableRow>
                      <TableRow className={classes.rowheight}>
                        <TableCell>{t("Report.Payroll.Receipt.PatientName")}:</TableCell>
                        <TableCell>{this.state.selectedObject.username}</TableCell>
                      </TableRow>
                      <TableRow className={classes.rowheight}>
                        <TableCell style={{ borderBottom: 'none' }}><b>{t("Report.Payroll.Receipt.OrderDetail")}</b></TableCell>
                      </TableRow>
                      <TableRow className={classes.rowheight}>
                        <Table size="small" aria-label="a dense table">
                          {/* <TableHead> */}
                          <TableRow>
                            <TableCell>{t("Report.Payroll.Receipt.PrescriptionNumber")}</TableCell>
                            <TableCell align="right">{t("Report.Payroll.Receipt.RxNumber")}</TableCell>
                            <TableCell align="right">{t("Report.Payroll.Receipt.FillID")}</TableCell>
                          </TableRow>
                          {/* </TableHead> */}
                          <TableBody>
                            {/* {rows.map((row) => ( */}
                            <TableRow className={classes.rowheight}>
                              <TableCell component="th" scope="row">
                                {this.state.selectedObject.rxno}
                              </TableCell>
                              <TableCell align="right">{this.state.selectedObject.prescriptionnumber}</TableCell>
                              <TableCell align="right">{this.state.selectedObject.fillid}</TableCell>
                            </TableRow>
                            {/* ))} */}
                          </TableBody>
                        </Table>
                      </TableRow>
                      <TableRow className={classes.rowheight}>
                        <TableCell style={{ borderBottom: 'none' }}><b>{t("Report.Payroll.Receipt.Signature")}</b></TableCell>
                      </TableRow>
                      <TableRow className={classes.rowheight}>
                        <TableCell><Avatar style={{ border: '1px solid rgba(224, 224, 224, 1)', borderRadius: '0%', width: '100%', height: '150px' }} alt="" src={(this.state.selectedObject.psignature_url !== null && this.state.selectedObject.psignature_url !== '') ? this.state.selectedObject.psignature_url : 'https://upload.wikimedia.org/wikipedia/commons/a/ac/No_image_available.svg'} /></TableCell>
                      </TableRow>
                      <TableRow className={classes.rowheight}>
                        <TableCell style={{ borderBottom: 'none' }}><b>{t("Report.Payroll.Receipt.PickedUpBy")}</b></TableCell>
                      </TableRow>
                      <TableRow className={classes.rowheight}>
                        <TableCell>{t("Report.Payroll.Receipt.FirstName")}:</TableCell>
                        <TableCell>{this.state.selectedObject.pfirst_name}</TableCell>
                      </TableRow>
                      <TableRow className={classes.rowheight}>
                        <TableCell>{t("Report.Payroll.Receipt.LastName")}:</TableCell>
                        <TableCell>{this.state.selectedObject.plast_name}</TableCell>
                      </TableRow>
                      <TableRow className={classes.rowheight}>
                        <TableCell>{t("Report.Payroll.PatientDetail.BadgeNumber")}:</TableCell>
                        <TableCell>{this.state.selectedObject.member_id}</TableCell>
                      </TableRow>
                      <TableRow className={classes.rowheight}>
                        <TableCell>{t('Report.Payroll.Receipt.IDNo')}:</TableCell>
                        <TableCell>{this.state.selectedObject.pdrivers_license_no}</TableCell>
                      </TableRow>
                      <TableRow className={classes.rowheight}>
                        <TableCell><Avatar style={{ borderRadius: '0%', width: '60%', height: '150px' }} alt="" src={(this.state.selectedObject.ppicture_url !== null && this.state.selectedObject.ppicture_url !== '') ? this.state.selectedObject.ppicture_url : 'https://upload.wikimedia.org/wikipedia/commons/a/ac/No_image_available.svg'} /></TableCell>
                      </TableRow>
                    </TableBody>)
                    :
                    (<TableBody>
                      <TableRow>
                        <TableCell colSpan={5}>{t("Report.Payroll.NoDataFound")}</TableCell>
                      </TableRow>
                    </TableBody>)
                }
              </Table>
            </DialogContent>
          </Dialog>
        </div>
        <Box component="div">
          <Grid container direction={'row'} alignItems={'center'} justifyContent={'flex-end'} spacing={0} sx={{ ml: 0, mr: 1, width: '100%', border: 'solid 1px #babfc7', borderBottom: 'none' }}>
            <Grid item xs={3} md={3} sx={{ textAlign: 'end' }}>
              <Tooltip key="clear-filters" title={t("Report.Payroll.ClearFiltersTooltip")}>
                <IconButton onClick={() => this.clearFilters()} style={{ backgroundColor: "#00a7e1" }}>
                  <CloseIcon style={{ color: "white" }} />
                </IconButton>
              </Tooltip>
              <Tooltip key="export-csv" title={t("Report.Payroll.ExportCSVTooltip")}>
                <IconButton
                  style={{ marginRight: '0' }}
                  aria-label="ExportCSV"
                  onClick={() => { this.exportCSV() }}
                  disabled={this.state.isButtonDisabled}
                >
                  <img alt="download" src={download} style={{ height: '32px', width: '32px', cursor: 'pointer' }} />
                </IconButton>
              </Tooltip>
            </Grid>
          </Grid>
        </Box>
        {this.state.accountValues.length && this.state.boxvalues.length ?
          <ReportsAGGrid
            columnDefs={columnDefs}
            sideBar={false}
            suppressMenuHide={true}
            rowData={data}
            defaultColDef={{
              flex: 1,
              minWidth: 150,
              floatingFilter: true,
              filter: 'agTextColumnFilter',
              filterParams: {
                filterOptions: [{
                  displayKey: 'searchtext',
                  displayName: 'Search Text',
                  predicate: (cellValue) => cellValue
                }],
                maxNumConditions: 1,
              },
              resizable: true,
              sortable: true,
              menuTabs: ['generalMenuTab', 'columnsMenuTab'],
            }}
            onGridReady={this.onGridReady}
          />
          : null
        }
      </div>
    );
  }
}

EnhancedTable.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles, { withTheme: true })(withTranslation()(EnhancedTable));



// WEBPACK FOOTER //
// ./src/components/reports/payroll-deductions/index.js